import {SET_ADVANCED_SEARCH_TAB, RECEIVE_TAB_DATA, REQUEST_TAB_DATA, SET_TAB_ERROR} from '../constants/ActionTypes';
import tabs from '../scripts/SearchOptionsAdvanced.js';

const initialState = {
    isFetching: false,
    isLoadingError: false,
    tabs: tabs.filter(tab => tab.name !== 'all').map( (tab, index) => index === 0 ? {...tab, active: true} : tab),
    activeTab: tabs.filter(tab => tab.name !== 'all')[0].name
};

export default function advancedSearch(state = initialState, action) {
    switch (action.type) {
        case SET_TAB_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case REQUEST_TAB_DATA:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case SET_ADVANCED_SEARCH_TAB:
            return {
                ...state,
                tabs: state.tabs.map(tab => ((tab.active && tab.name !== action.name) || (!tab.active && tab.name === action.name)) ? {...tab, active: !tab.active} : tab),
                activeTab: action.name
            };
        case RECEIVE_TAB_DATA:
            return {
                ...state,
                tabs: state.tabs.map(tab => (tab.active ? {...tab, data: action.data} : tab)),
                isFetching: false
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/advancedSearch.js